import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['effect', 'overlay'];
  static values = { delay: { type: Number, default: 3000 } };

  connect() {
    // Every animated element in the effect ends at once, so debounce the batch of events into one timer
    this.effectTarget.addEventListener('animationend', this.__handleEnded);
    this.overlayTarget.addEventListener('click', this.__handleReplay);
  }

  disconnect() {
    this.effectTarget.removeEventListener('animationend', this.__handleEnded);
    this.overlayTarget.removeEventListener('click', this.__handleReplay);
    if (this.__delayTimeout) clearTimeout(this.__delayTimeout);
  }

  __handleEnded = () => {
    if (this.__delayTimeout) clearTimeout(this.__delayTimeout);
    this.__delayTimeout = setTimeout(() => {
      this.overlayTarget.classList.add('visible');
    }, this.delayValue);
  };

  __handleReplay = () => {
    if (this.__delayTimeout) clearTimeout(this.__delayTimeout);
    this.overlayTarget.classList.remove('visible');
    this.effectTarget.getAnimations({ subtree: true }).forEach((animation) => {
      animation.cancel();
      animation.play();
    });
  };
}
